<template>
	<div class="main-component">
		<!-- 
			1.通过路由配置将组件渲染到命名视图keepAlive时，组件会被缓存
			2.通过name标识各个页面，这样页面不同时即使key相同也不会复用组件
			3.通过改变key，使目标页面重新渲染
		 -->
		<keep-alive max="10">
			<router-view :key="`${$route.name}-${$route.meta.key}`" name="keepAlive"></router-view>
		</keep-alive>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'Main',
	data() {
		return {
			
		};
	},
};
</script>

<style lang="scss" scoped>
.main-component {
}
</style>
